module.exports = __webpack_public_path__ + "media/images/scan-tag-9fced1ed6a1b7f022b676fa07174930f.png";